import { z } from 'zod';
import { uuid, isoTimestamp } from '../schemas/common.js';
/**
 * A recipe's cook log (RECEPTEN.md — "what we cook a lot and what not").
 *
 * Each entry records one cook — **when**, and **by whom** — so the app can tell a
 * weekly favourite from a recipe saved and never made, and show when it was last
 * cooked. It is a jsonb array on the `recepten` row (migration 034), not its own
 * table: the same "history lives on the row, not in a log table" choice todos
 * makes (shared/src/todos/log.ts). It rides the ordinary per-row LWW sync, so an
 * entry is only as durable as the edit it accompanies — two phones logging the
 * same recipe at once keep one row and one entry, the accepted module-wide trade.
 *
 * A cook is logged from two places: the cook-mode "Heb je dit gekookt?" prompt at
 * the last step, and a manual "Gekookt vandaag" button on the recipe (for a cook
 * that skipped cook mode). The count is the array length.
 */
export const cookedLogEntry = z.object({
    /** When it was cooked (wall clock, for display — not the LWW `updated_at`). */
    at: isoTimestamp,
    /** Who cooked it, or null when unknown. */
    by: uuid.nullable(),
});
/**
 * Keep a recipe's cook history bounded. A recipe cooked more than this is plainly
 * a favourite; the count saturates rather than the row growing without limit — the
 * same trade the todos log makes with its own cap.
 */
export const COOKED_LOG_MAX = 100;
/** Build one cook entry, stamped with the current wall clock. */
export function cookedEntry(by) {
    return { at: new Date().toISOString(), by };
}
/**
 * Append a cook to the log, oldest first, trimmed to `COOKED_LOG_MAX`.
 * `existing` may be null/undefined (a recipe never cooked yet).
 */
export function appendCooked(existing, entry) {
    const next = [...(existing ?? []), entry];
    return next.length > COOKED_LOG_MAX ? next.slice(next.length - COOKED_LOG_MAX) : next;
}
//# sourceMappingURL=log.js.map